import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { PersistLogin, RequireAuth } from "./components";

import routes from "./data/routes/index";

// Enums
import { ROLES } from "./config/roles";
import { ROUTE_TYPES } from "./config/routeTypes";

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        {routes.map((route, index) => {
          if (route.type === ROUTE_TYPES.Public) {
            return (
              route.element && (
                <Route
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  element={<route.element />}
                />
              )
            );
          }
        })}

        {/* Protected Routes */}
        <Route element={<PersistLogin />}>
          {routes.map((route, index) => {
            if (route.type === ROUTE_TYPES.Protected) {
              return (
                route.element && (
                  <Route
                    key={index}
                    element={
                      <RequireAuth
                        allowedRoles={
                          route.allowedRoles
                            ? route.allowedRoles // if roles specified, apply the role based routing
                            : [...Object.values(ROLES)] // else, enable route for all roles
                        }
                      />
                    }
                  >
                    <Route
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      element={<route.element />}
                    />
                  </Route>
                )
              );
            }
          })}
        </Route>

        {/* Any Routes */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
